<template>


<div class="fixed-top" id="header">


  <b-navbar toggleable="lg" variant="" type=""  >
    <b-navbar-brand href="#">
      <router-link to="/">
      <table>
        <tbody>
          <tr>
              <td rowspan="5">  <b-img class="logo" src="../assets/apdcl_logo.png" fluid   alt="logo"></b-img></td>
          </tr>
            <tr>
              <td id="title-a" class="title-a text-blue ">অসম শক্তি বিতৰণ কোম্পানী লিমিটেড
            </td>
            </tr>
            <tr>
              <td id="tagline-a"  class="tagline-a text-blue"> অসম চৰকাৰৰ ৰাজহুৱা খণ্ডৰ এটি পৰিসীমিত কোম্পানী</td>
            </tr>
            <tr>
              <td id="title-e" class="title-e text-blue">ASSAM POWER DISTRIBUTION COMPANY LIMITED</td>
            </tr>
            <tr>
              <td id="tagline-e" class="tagline-e text-blue">A Govt. of Assam Public Limited Company</td>
            </tr>
        </tbody>
      </table>
    </router-link>
  </b-navbar-brand>

  <b-navbar-toggle target="nav-collapse" style="border:none; outline: none;">
      <template>
        <div style="border:solid 1px black;border-radius:3px;font-size: 2rem;text-align:right">
        <b-icon icon="list"  ></b-icon>
      </div>
      </template>
    </b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav class="nav-bgcolor responsiveNavbar" style="padding-left:2rem;z-index:10;">


      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
          <b-nav-item href="#"><router-link class="r-link" to="/">Home</router-link></b-nav-item>
          <b-nav-item href="#"><router-link class="r-link" to="/ActsAndRules">Acts & Policies</router-link></b-nav-item>
          <!-- <b-nav-item href="#"><router-link class="r-link" to="/Tender">Tender</router-link></b-nav-item> -->
          <b-nav-item-dropdown class="r-link" text="Tender" right>
              <b-dropdown-item href="TenderCurrent"><span class="dropdownItem" >Current Financial Year</span></b-dropdown-item>
              <b-dropdown-item href="TenderPrevious"><span class="dropdownItem" >Previous Financial Year</span></b-dropdown-item>
              <b-dropdown-item href="TenderArchive"><span class="dropdownItem" >Archive</span></b-dropdown-item>
          </b-nav-item-dropdown>

          <!-- <b-nav-item-dropdown class="r-link" text="Newsroom" right>
            <b-dropdown-item href="#"><router-link to="/Newsletter">Newsletter</router-link></b-dropdown-item>
            <b-dropdown-item href="#"><router-link to="/BijuleeNewsBulletin">Bijulee News Bulletin</router-link></b-dropdown-item>
              <b-dropdown-item href="#"><router-link to="/PressRelease">Press Release</router-link></b-dropdown-item>
            <b-dropdown-item><a href="https://www.youtube.com/watch?v=tgSJKMbjFIc&feature=youtu.be" target="_blank">Talk Show about APDCL</a></b-dropdown-item>
            <b-dropdown-item href="#"><router-link to="/Testimonial">Testimonials</router-link></b-dropdown-item>
          </b-nav-item-dropdown> -->

          <b-nav-item-dropdown class="r-link" text="News & Media" right>
            <b-dropdown-item href="Award"><span class="dropdownItem " >Awards and Recognition</span></b-dropdown-item>
            <b-dropdown-item href="Newsletter"><span class="dropdownItem" >Newsletter</span></b-dropdown-item>
            <b-dropdown-item href="BijuleeNewsBulletin"><span class="dropdownItem" >Bijulee News Bulletin</span></b-dropdown-item>
            <b-dropdown-item href="PressRelease"><span class="dropdownItem" >Press Release</span></b-dropdown-item>
            <b-dropdown-item href="https://www.youtube.com/watch?v=tgSJKMbjFIc&feature=youtu.be" target="_blank"><span class="dropdownItem" >Talk Show about APDCL</span></b-dropdown-item>
            <b-dropdown-item href="Testimonial"><span class="dropdownItem" >Testimonials</span></b-dropdown-item>
            <b-dropdown-item href="Workshop"><span class="dropdownItem" >Workshop & Seminar</span></b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item href="#"><router-link class="r-link" to="/Contact">Contact</router-link></b-nav-item>

          <b-nav-item><div id="login">
            <b-button v-b-modal.modal-header size="sm"  variant="outline-danger" style="margin-top: -5px;">
            Log In </b-button></div>
          </b-nav-item>
      </b-navbar-nav>
    </b-collapse>

  </b-navbar>
  <span class="support text-orange" id="support">
      24x7 Customer Support
      <span class="text-danger"><b-icon icon="headphones" variant="danger" scale="1"></b-icon> 1912</span> or
      <b-icon icon="envelope" variant="danger" scale="1"></b-icon>
      <span class="text-danger"> support@apdcl.org</span>
  </span>

  <span class="language" id="language" >
      <router-link class="r-link customSpan" to="/Assamese">অসমীয়া</router-link>
      <!-- <router-link class="r-link customSpan" to="/">অসমীয়া</router-link> -->
    </span>


  <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
    <span class="data" id="modalMsg"> DEMO </span>
    <br><br>
      <b-button  style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
  </b-modal>


  <b-modal
  no-close-on-esc
  no-close-on-backdrop
   class="modal fade"
   id="modal-header"
   hide-footer
   title="Log In to Your Account"
   
   >
    <div>
      <b-overlay
        :show="show"
        spinner-variant="primary"
        spinner-large
        rounded="sm"
        style="z-index:10000;position:absolute"
        variant="dark"
        id="loader"
      >



    <br>
      <!-- USER LOGIN-->
        <div id="userDiv" class="showDiv" >
            <label>Enter Mobile Number  </label>
            <b-input-group class="mb-2" style="width:100%;padding-top:0px;padding-bottom:10px;">
              <b-input-group-prepend is-text>
                <b-icon icon="phone"></b-icon>
              </b-input-group-prepend>
              <b-form-input type="text" id="mobileNo" value=""  name="mobNo" autocomplete="off" placeholder="Mobile Number" :readonly="mobileReadonly"></b-form-input>
            </b-input-group> 
            <span style="display:none;color:red;text-align: center;" id="errorMsg" v-show="loginErrorMsg">{{ loginErrorMsg }}</span>
            <div id="sendOtpBtn"  style="padding-top:7px;display:block" v-show="!otpSent && !otpSentFL && !alreadyLoggedIn">
              <b-row>
                <b-col cols="12">
                      <b-button block @click="sendOtp()" variant="primary">Log In</b-button>
                </b-col>
              </b-row>
            </div>
            <div id="alreadyLoggedInDiv"  style="padding-top:7px; display:none" v-show="alreadyLoggedIn && !otpSentFL" >
              <b-row>
                <b-col cols="12" style="color:red;text-align: center;">
                  User is already logged in a different PC.
                  Click on Force Logout to terminate the active session.
                </b-col>
              </b-row>
              <br>
              <b-row>
                <b-col cols="12">
                      <b-button block @click="sendOtpFL()" variant="danger">Force Logout</b-button>
                </b-col>
              </b-row>
            </div>

            <div  id="otpDiv"  style="display:none" v-show="otpSent">
              <label>Enter OTP  </label>
              <b-input-group class="mb-2" style="width:100%;">
              <b-input-group-prepend is-text>
                <b-icon icon="check2-circle"></b-icon>
              </b-input-group-prepend>
              <b-form-input type="text" id="otpNo"   autocomplete="off" placeholder="Enter OTP" required></b-form-input>
            </b-input-group>
            <span style="color:red;padding-left:40%" id="otpInvalid"> </span>
            <b-row>
              <b-col cols="12" offset="">
                  <b-button block variant="primary" @click="loginUser()">Verify OTP & Log In </b-button>
                  <b-button block  @click="resendOtp()" variant="outline-primary">Resend OTP</b-button>
              </b-col>
            </b-row>
          </div>
          <div  id="otpDivFL" style="display:none" v-show="otpSentFL">
              <label>Enter OTP  </label>
              <b-input-group class="mb-2" style="width:100%;">
              <b-input-group-prepend is-text>
                <b-icon icon="check2-circle"></b-icon>
              </b-input-group-prepend>
              <b-form-input type="text" id="otpNoFL"   autocomplete="off" placeholder="Enter OTP" required></b-form-input>
            </b-input-group>
            <span style="color:red;padding-left:40%" id="otpInvalidFL"> </span>
            <b-row>
              <b-col cols="12" offset="">
                  <b-button block variant="danger" @click="forceLogout()">Verify OTP & Force Logout </b-button>
              </b-col>
            </b-row>
          </div>
       <br>
          <b-row>
            <b-col cols="12" style="text-align:center">
                <span  >Don't have an Account? <br>
                <router-link to="/ConsumerRegistration">Register Now</router-link>
              </span>
            </b-col>
          </b-row>
          </div>

          <br><br>
      </b-overlay>
    </div>
  </b-modal>


</div>

</template>


<script scoped="true">

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

var user = 0;

export default{
  computed:{
   userIdState() {
      return this.user_id.length == 12 ? true : false
      //this.login()
    }
  },
  data() {
      return {
        selected: 'consumer',
        user_id: '',
        show: false,
        mobileNo :'',
        otpSent: false,
        otpSentFL: false,
        alreadyLoggedIn: false,
        loginErrorMsg: '',
        mobileReadonly: false
      }
    },
  created () {
    // When the user scrolls down 50px from the top of the document, resize the header's font size
    window.addEventListener('scroll', this.scrollFunction);
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollFunction);
  },
  methods:{
    scrollFunction(event) {
      if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        document.getElementById("header").style.backgroundColor = "#eeeeee";
        document.getElementById("title-a").style.fontSize = "1.3rem";
        document.getElementById("title-e").style.fontSize = "1.3rem";
        document.getElementById("tagline-a").style.fontSize = "0rem";
        document.getElementById("tagline-e").style.fontSize = "0rem";
        document.getElementById("support").style.fontSize = "0rem";
        document.getElementById("language").style.marginTop = "-95px";
      } else {
        document.getElementById("header").style.backgroundColor = "";
        document.getElementById("title-a").style.fontSize = "1.3rem";
        document.getElementById("title-e").style.fontSize = "1.3rem";
        document.getElementById("tagline-a").style.fontSize = "0.9rem";
        document.getElementById("tagline-e").style.fontSize = "0.9rem";
        document.getElementById("support").style.fontSize = "0.8rem";
        document.getElementById("language").style.marginTop = "-115px";
      }
    },


   
   
    sendOtp()
    {
    var mobile = document.getElementById("mobileNo").value;

      if((mobile.length != 10)){
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return;
      }
      var parent=this;
     
      let data = JSON.stringify({
        "mobileNo": mobile,
        "type": "new",
        "src" : "portal"
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee+'/auth/login',
        headers: { 
           'Content-Type': 'application/json'
        },
        data : data
      };

      this.show=true;

      axios.request(config)
      .then((response) => {
       // console.log(response.data);
        parent.show=false;
        if (response.data.status == "success") {
          parent.$bvToast.toast('OTP Sent Successfully !', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
            parent.mobileReadonly = true;
            parent.otpSent = true;
            parent.loginErrorMsg = '';
          }
         else if (response.data.status == "error" && response.data.message == "already logged in") {
          console.log("exist");
            parent.mobileReadonly = true;
            parent.loginErrorMsg = '';
            parent.alreadyLoggedIn = true;
            
          }
          else if (response.data.status == "error") {
            
            parent.loginErrorMsg = response.data.message;
            
          }
      })
      .catch((error) => {
        console.log(error);
      });

    },
    resendOtp()
    {
      var parent =this;
      var mobile = document.getElementById("mobileNo").value;
      let data = JSON.stringify({
        "mobileNo": mobile,
        "type": "old",
        "src" : "portal"
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee+'/auth/login',
        headers: { 
           'Content-Type': 'application/json'
        },
        data : data
      };

      parent.show= true;
      axios.request(config)
      .then((response) => {
      
        parent.show= false;
        if (response.data.status == "success") {
          parent.$bvToast.toast('OTP Sent Successfully !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
        }
      else {
          parent.$bvToast.toast('OTP Could not Sent !', {
            title: `Error`,
            variant: 'danger',
            solid: true
          });
        }
      })
      .catch((error) => {
        console.log(error);
        parent.show = false;
        parent.$bvToast.toast('Network Error !', {
          title: `Failure`,
          variant: 'danger',
          solid: true
        });
      });
    },
    loginUser()
    {
 
      var mobile = document.getElementById("mobileNo").value;
      var otpNo = document.getElementById("otpNo").value;

      if((mobile.length != 10)){
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return;
      }
     

      let data = JSON.stringify({
        "mobileNo": mobile,
        "otpNo": otpNo,
        "src":"portal"
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee+'/auth/otp/verify',
        headers: { 
           'Content-Type': 'application/json'
        },
        data : data
      };

      var parent=this;
      this.show=true;
      axios.request(config)
      .then((response) => {
          if (response.data.status == "success") {
          var accessToken=response.data.accessToken;
          sessionStorage.setItem("accessToken", response.data.accessToken);
          sessionStorage.setItem("consList", JSON.stringify(response.data.consList));
          sessionStorage.setItem("mobile", mobile);
          var consNo = response.data.consList[0];
          var consType;
         
        let data = JSON.stringify({
            "consNo": consNo,
            "mobileNo":mobile
          });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: parent.$urlCommon+'/api/web/auth/getConsDetails',
        headers: { 
          'Authorization': accessToken, 
          'Content-Type': 'application/json'
        },
        data : data
      };
    
      axios.request(config)
      .then((response) => {
        parent.show=false;
        console.log(response.data);
        if(response.data.message=="00")
          {
          sessionStorage.setItem("selectedCons", consNo);
          consType = response.data.connType;
          if(consType == "POSTPAID")
              {
                window.location.href = "/website/ConsumerDashboardPostpaid";
                return false;
        
              }
          else if( consType == "SMART POSTPAID")
          {
            window.location.href = "/website/ConsumerDashboardSmartPostpaid";
            return false;
    
          }
          else  if(consType == "PREPAID")
              {
                window.location.href = "/website/ConsumerDashboardPrepaid";
                return false;
               
              }
          else  if(consType == "SMART PREPAID")
              {
                window.location.href="/website/ConsumerDashboardSmartPrepaid";
                return false;
               
              }
          }
        else{
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="Consumer Not Found";
        }
      })
      .catch((e) => {
        parent.show=false;
        console.log("Caught :::::::::::::::", e.message);
        if(e.message=="Network Error")
        {
          parent.$bvModal.show('redirectModal');
          document.getElementById("redirectModalMsg").innerHTML="Session Expired, Please log in again";
        }
      });
   
    }
          else
          {
            parent.show=false;
            parent.$bvToast.toast('OTP Invalid !', {
              title: `Failure`,
              variant: 'danger',
              solid: true
            });
          }
      })
      .catch((error) => {
        console.log(error);
        parent.show=false;
            parent.$bvToast.toast('Network Error !', {
              title: `Failure`,
              variant: 'danger',
              solid: true
            });
      });

    },
    
    sendOtpFL()
    {
    var mobile = document.getElementById("mobileNo").value;

      if((mobile.length != 10)){
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return;
      }
      var parent=this;
      this.show=true;

      let data = JSON.stringify({
        "mobileNo": mobile,
        "type": "new",
        "src" : "portal-fl"
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee+'/auth/login',
        headers: { 
           'Content-Type': 'application/json'
        },
        data : data
      };


      axios.request(config)
      .then((response) => {
       // console.log(response.data);
        parent.show=false;
        if (response.data.status == "success") {
          parent.$bvToast.toast('OTP Sent Successfully !', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
            parent.mobileReadonly = true;
            parent.otpSentFL = true;
            parent.alreadyLoggedIn = false;
          }
        
      })
      .catch((error) => {
        console.log(error);
      });

    },
    forceLogout()
    {
      var parent =this;
      var mobile = document.getElementById("mobileNo").value;
      var otpNo = document.getElementById("otpNoFL").value;

      let data = JSON.stringify({
        "mobileNo": mobile,
        "otpNo": otpNo,
        });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee+'/auth/forceLogout',
        headers: { 
           'Content-Type': 'application/json'
        },
        data : data
      };

      parent.show= true;
      axios.request(config)
      .then((response) => {
      
        parent.show= false;
        if (response.data.status == "success") {
          parent.$bvToast.toast('Force Log Out Successfull. Please Log In now', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
          document.getElementById("otpDivFL").style.display="none";
          document.getElementById("sendOtpBtn").style.display="block";
          document.getElementById("alreadyLoggedInDiv").style.display="none";
        }
      else {
          parent.$bvToast.toast('Invalid OTP!', {
            title: `Error`,
            variant: 'danger',
            solid: true
          });
        }
      });
    },

 
  },
    
  mounted(){
    // var url_string = window.location.href;
    // var url = new URL(url_string);
    // var mobile = url.searchParams.get("mobileNo");
    // console.log("mobile:::::"+mobile)
    // if(mobile>0)
    // {
    //   this.$bvModal.show("modal-login");
    //   this.mobileNo=mobile;
    //   }
  
  }
}

</script>

<style lang="scss" scoped="true" >



#header
{
  transition: 0.6s;
}

.title-a
{
  font-size: 1.3rem;
  font-weight: 900;
  margin-top: 0px;
  letter-spacing: 0.5px;

}
.title-e
{
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.5px;

}
.tagline-a
{
    font-size: 0.9rem;
    font-style: italic;

}
.tagline-e
{
    font-size: 0.9rem;
    font-style: italic;

}

.responsiveNavbar{

}

table
{
  color:#e4dbdb;
}
td
{
  text-align: left !important;
}
.text-orange
{
  color: #ff5722
}
.text-blue
{
  color: #01579b;
}
.border
{
  border:1px solid;
}
.support
{
  font-size: 0.8rem;
  float: right;
  margin-top: -110px !important;
  margin-right: 170px;
  text-shadow: 0px 0px 1px #0000005c;
}
.language
{
  float: right;
  margin-top: -115px ;
  margin-right: 25px;
  position:relative;
  z-index:1000;
}
.customSpan
{
background-color: #fff78d;
padding: 4px 10px 4px 10px;
font-weight: 600;
border-radius: 2px;
}

#header,#title-e,#title-a,#tagline-a,#tagline-e,#support,#language
{
  transition: 0.5s;
}

.form-popup {
  display: none;
  position: fixed;
  bottom: 0;
  right: 15px;
  border: 3px solid #f1f1f1;
  z-index: 9;
}
.logo{
    height:75px;
    width:75px;
    margin-right:20px;
}


.hideDiv
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;

    padding: 0rem;
}
.showDiv
{
 visibility: visible;
 opacity: 1;
}
@media only screen and (max-width: 990px) {
.tagline-a, .tagline-e, .language, .support{
  display:none !important;
}
.title-e, .title-a{
  font-size: 1rem !important;
  font-weight: 600 !important;
  letter-spacing: 0px !important;

}
.logo{
  height:35px;
  width:35px;
  margin-right:0px;
}
.nav-bgcolor
{
  background-color:white;
}
.responsiveNavbar{
  padding-left: 20px;
  padding-bottom: 10px;
  background-color: #ffff;
  opacity: 0.95;
}
}
@font-face {
  font-family: Assamese_Font;
  src: url("../assets/Assamese_font/KirtanUni.ttf");
}
div{
    font-family: arial, Assamese_Font;
}


</style>